// Download All OMA logic
/////////////////////////////////////////////
import { categoryListGlobalFit } from "./oma-files-filter.js";

const buttonDownloadAll = document.querySelector(".js-button-download-all");

const updateDownloadAllButton = (button, hrefValue) => {
  const downloadValue = hrefValue.toString();
  const downloadFileName = downloadValue.split("/");
  button.href = downloadValue;
  button.download = downloadFileName[downloadFileName.length - 1];
};

const GlobalFitControlls = document.querySelector(
  ".js-oma-files__filter-controlls",
);

if (GlobalFitControlls) {
  const filterRadio = document.querySelectorAll(
    ".js-oma-files__filter-controlls .radio input",
  );

  // Init download all button
  updateDownloadAllButton(
    buttonDownloadAll,
    GlobalFitControlls.querySelector("input:checked").dataset.downloadHref,
  );

  let searchResetFilter = () => {
    if (categoryListGlobalFit !== undefined) {
      categoryListGlobalFit.search("", ["oma-files__product-title"]);
      document.querySelector(".pagination--full").style.display = "flex";
    }
  };

  Array.from(filterRadio).forEach((radio) => {
    radio.addEventListener("change", (el) => {
      let filterType = el.target.value;
      updateDownloadAllButton(
        buttonDownloadAll,
        el.target.dataset.downloadHref,
      );
      if (categoryListGlobalFit !== undefined) {
        document
          .querySelector(".oma-files__grid--full")
          .removeAttribute("style");
      }

      // document
      //   .querySelector(".oma-files__grid--full")
      //   .removeAttribute("style");

      //

      if (filterType == "sort-by-az") {
        document
          .querySelectorAll(".oma-files__category")
          .forEach((category) => {
            category.classList.remove("show");
          });

        document
          .querySelector(".oma-files__category--az")
          .classList.add("show");

        document.querySelector("#global-fit-search--full-list").value = "";
        // document.querySelector(".pagination--full").style.display = "flex";
        searchResetFilter();
      }

      if (filterType == "global-fit") {
        document
          .querySelectorAll(".oma-files__category")
          .forEach((category) => {
            category.classList.remove("show");
          });

        document
          .querySelector(".oma-files__category--global-fit")
          .classList.add("show");

        document.querySelector("#global-fit-search--full-list").value = "";
        // document.querySelector(".pagination--full").style.display = "flex";
        searchResetFilter();
      }

      if (filterType == "wire") {
        document
          .querySelectorAll(".oma-files__category")
          .forEach((category) => {
            category.classList.remove("show");
          });

        document
          .querySelector(".oma-files__category--wire")
          .classList.add("show");

        document.querySelector("#global-fit-search--full-list").value = "";
        searchResetFilter();
      }

      if (filterType == "regular-collections") {
        document
          .querySelectorAll(".oma-files__category")
          .forEach((category) => {
            category.classList.remove("show");
          });

        document
          .querySelector(".oma-files__category--regular-collections")
          .classList.add("show");

        document.querySelector("#global-fit-search--full-list").value = "";
        // document.querySelector(".pagination--full").style.display = "flex";
        searchResetFilter();
      }
    });
  });
}

// Rellax parallax
import Rellax from "rellax";
const rellax = new Rellax(".rellax");
